import React from 'react'
import { Link } from 'react-router-dom'

const Links = () => {
    return (
        <div className='hidden md:flex  fixed z-[99] top-0 right-0 h-[75%] flex-col justify-end items-end'>
            {/* <div className='h-[147px]  '>
                <Link to={'/claims'} className='absolute right-0 bottom-0  w-[147px] h-[59px] bg-[#060606] px-[2px]  flex justify-center items-center rounded-b-[30px] rotate-[90deg] translate-x-[44px]'>
                    <p className=' text-white '>Get Quote  </p>
                </Link>
            </div> */}
            {/* <div className='h-[147px] '>
                <div className='relative  w-[147px] h-[59px] bg-[#5A5A5A] px-[2px]  flex justify-center items-center rounded-b-[30px] rotate-[90deg] translate-x-[44px]'>
                    <p className=' text-white '>Manage Policies</p>
                </div>
            </div>
            */}
            <div className='h-[147px] '>
                <Link to={'/claims'} className='absolute right-0 bottom-0   w-[147px] h-[59px] bg-[rgb(193,42,18)] px-[2px]  flex justify-center items-center rounded-b-[30px] rotate-[90deg] translate-x-[44px]'>
                    <p className=' text-white '>Report Claims</p>
                </Link>
            </div>
        </div>
    )
}

export default Links